import { RegexEnum } from '../../libs/enums';
import { mustBeFilled, mustBeLessThan, mustMatchFormat } from '../../libs/validators';

export const inputLastNameConfig = {
  description: 'Comme inscrit sur votre acte de naissance',
  label: 'Nom complet de naissance',
  name: 'lastName',
  validators: {
    format: [
      mustMatchFormat(
        RegexEnum.PERSON,
        'Veuillez utiliser uniquement des caractères alpha-numériques ou de ponctuations',
      ),
      mustBeLessThan(256),
    ],
    submit: mustBeFilled(
      'Veuillez renseigner votre nom complet de naissance ou cocher la case si vous ne disposez pas de nom renseigné sur votre acte de naissance.',
    ),
  },
};
